//import { createPopper } from '@popperjs/core';
//import * as bootstrap from 'bootstrap';

//import add, { selectSomething } from './components/example';
import "./components/header";
import "./components/numbers";
import "./components/modal";

//console.log( add( 1, 2 ) );
//console.log( selectSomething() );

// a hack to hide empty query blocks
jQuery(".wp-block-query.is-layout-flow.wp-block-query-is-layout-flow").each(
  function () {
    if (jQuery(this).is(":empty")) {
      jQuery(this).parent().hide();

      // Fix for dropdowns in search results page without search results
      if (jQuery(this).parent().closest(".nav-dropdown").length) {
        jQuery(this).parent().closest(".nav-dropdown").css("left", "0");
      }
    }
  }
);
